import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {EPSGCodes, FourDService, Project} from '4d-mapper';
import {MatAutocomplete, MatDialog, MatSlideToggleChange, MatSnackBar} from '@angular/material';
import {MapService} from '../../../commons/map.service';
import {ClickDisplay, MapClickHandler, MapComponent} from '../map.component';
import {BaseComponent} from '../../../commons/BaseComponent';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import { Constants } from '../../../commons/Constants';
import {TranslateService} from '@ngx-translate/core';

class Annotation {
  id: number;
  name: string;
}

const Cesium = (<any>window).Cesium;

@Component({
  selector: 'app-project-setting',
  templateUrl: './project-setting.component.html',
  styleUrls: ['../map_commons.scss', './project-setting.component.scss']
})
export class ProjectSettingComponent extends BaseComponent implements OnInit, OnDestroy, MapClickHandler {

  debug:boolean = Constants.debug_off;

  @Input('project') project: Project;
  @ViewChild('matAutocomplete', {static: false}) matAutocomplete: MatAutocomplete;
  feet_Meter = MapService.METER;
  Meter = MapService.METER;
  Feet = MapService.FEET;
  defaultAnnotation: Annotation = {id: -1, name: 'PROJECT.SETTING.SELECT_CLIP'};
  annotation: Annotation[] = [this.defaultAnnotation];
  baseModel: boolean;
  showGlobe: boolean = true;
  loading: boolean = true
  applyGlobal: boolean = false;
  resetLastLocation = false;
  selectedEPSGCode: any;
  number_precission:number = 2;

  /*
    Setting for viewing photos in its own window or in the navigation tab
   */
  // viewContextMenu = false;
  // viewContextMenuFloating = false;
  viewPhotoBucket = false;
  // viewLibraryTab = false;


  constructor(route: ActivatedRoute, router: Router, snackBar:
    MatSnackBar, dialog: MatDialog, public translate: TranslateService, private mapComp: MapComponent, private mapService: MapService, private fourD: FourDService, private location: Location) {
    super(router, snackBar, dialog)

    mapComp.activeDetails = this
    // if (!mapComp.activeTab)
    //   mapComp.setTab('layers')

    mapComp.detailsNav.open()
    mapService.onReady().subscribe(s => {

      this.loading = false
      this.project = this.mapService.currentProject;

      if ( ! this.project ) 
        return;

      if (this.project['baseModel'] !== undefined) {
        this.baseModel = this.project['baseModel'];
      }

      this.number_precission = 2;
      if (this.project['number_precission'] !== undefined) {
        this.number_precission = this.project['number_precission'];
      }
/*
      this.viewContextMenu = false;
      if (this.project['ui_viewContextMenu'] !== undefined) {
        this.viewContextMenu = this.project['ui_viewContextMenu'];
      }

      this.viewContextMenuFloating = false;
      if (this.project['ui_viewContextMenuFloating'] !== undefined) {
        this.viewContextMenuFloating = this.project['ui_viewContextMenuFloating'];
      }
*/
      this.viewPhotoBucket = false;
      if (this.project['ui_viewPhotoBucket'] !== undefined) {
        this.viewPhotoBucket = this.project['ui_viewPhotoBucket'];
      }

      //this.viewLibraryTab = false;
      //if (this.project['ui_viewLibraryTab'] !== undefined) {
      //  this.viewLibraryTab = this.project['ui_viewLibraryTab'];
      //}

    })
    if (this.mapService.annotations && this.mapService.annotations.length > 0) {
      this.mapService.annotations.forEach(annot => {
        // console.log(annot['annotationMode']);
        if (annot['annotationMode'] && (annot['annotationMode'] === 'area' || annot['annotationMode'] === 'volume') && annot['points'] && annot['points'].length > 0) {
          if (annot['clipPlanes']) {
            this.defaultAnnotation = {id: annot.id, name: annot.name};
            this.annotation.push(this.defaultAnnotation);
          } else {
            this.annotation.push({id: annot.id, name: annot.name});
          }
        }

      });
    }
  }

  init() {
    if ( this.debug ) { console.log ( 'project-settings :: onInit()'); }
    if (!this.project && this.mapService.currentProject) {
      this.project = this.mapService.currentProject;
    }
    if (this.project && this.project['EPSGCode']) {
      let search = this.fourD.V.searchByObject(EPSGCodes).equals('uid', this.project['EPSGCode'])
        // .equals('CSRType', this.CSRType)
      ;
      search.queryObservable().subscribe((result) => {
        if ( result.items && result.items.length > 0 ) {
          if ( this.debug ) { console.log ( 'project-settings :: onInit() setting EPSG', this.project['EPSGCode'], result.items ); }
          this.selectedEPSGCode = result.items[0];
        } else {
          this.selectedEPSGCode = null;
        }
      });
    }

    if (this.project && this.project['measurementUnit']) {
      this.feet_Meter = this.project['measurementUnit'];
    }

    if (this.project && !this.project['measurementUnit']) {
      this.saveMeasurementUnit();
    }
  }

/*
  changeContextMenu(b: any) {
    this.mapComp.viewContextMenu = this.viewContextMenu = b.checked;
    if (!this.mapComp.viewContextMenu) {
      this.mapComp.contextNav.close();
    }
  }
*/
  changeNumberPrecission() {
    // console.log ( '%c project-settings.comp %c changeNumberPrecission()', Constants._red, Constants._blue, this.number_precission, this.mapComp, this.mapComp.inspectorComp, this.mapComp.inspectorComp.selected );
      
    if ( this.mapComp && this.mapComp.inspectorComp && this.mapComp.inspectorComp.selected ) {
      this.mapComp.inspectorComp.selected['number_precission'] = this.number_precission;
    }
  }
/*
  changeContextMenuFloating(b: any) {
    this.mapComp.viewContextMenuFloating = this.viewContextMenuFloating = b.checked;
  }
*/
  // changeViewPhotoBucket(b: any) {
  //   this.mapComp.viewPhotoBucket = this.viewPhotoBucket = b.checked;
  // }

 // changeViewLibraryTab(b: any) {
  //  this.mapComp.viewLibraryTab = this.viewLibraryTab = b.checked;
  // }

  showBaseModel(b: any) {
    this.mapService.showBaseModel(b.checked);
    this.project['baseModel'] = b.checked;
    this.project.saveObservable().subscribe();
  }

  showGlobeOnCesium(event: MatSlideToggleChange) {
    this.mapService.showGlobeOnCesium(event.checked);
  }

  save() {

    // this.project['ui_viewContextMenu'] = this.viewContextMenu;
    // this.project['ui_viewContextMenuFloating' ] = this.viewContextMenuFloating;
    this.project['ui_viewPhotoBucket'] = this.viewPhotoBucket;
    // this.project['ui_viewLibraryTab'] = this.viewLibraryTab;

    if (this.selectedEPSGCode) {
      this.project['EPSGCode'] = this.selectedEPSGCode.uid;
    }
    this.project['measurementUnit'] = this.feet_Meter;
    this.project['number_precission'] = this.number_precission;
    if (this.resetLastLocation) {
      delete this.project.props['cameraPosition'];
      this.mapService.resetLastLocation = this.resetLastLocation;
    }
    this.project.saveObservable().subscribe();

    this.navigateBack(this.location);
  }

  cancel() {
    this.navigateBack(this.location);
  }

  clip() {
    if (this.defaultAnnotation) {
      if (this.defaultAnnotation.id === -1) {
        this.clearAllClipPlanes(false);
      } else {
        this.mapService.annotations.forEach(annotation => {
          // console.log(annotation['annotationMode']);
          if (annotation['annotationMode'] && (annotation['annotationMode'] === 'area' || annotation['annotationMode'] === 'volume') && annotation['points'] && annotation['points'].length > 0 && annotation.id === this.defaultAnnotation.id) {
            annotation['clipPlanes'] = true;
            annotation['points'].forEach(point => {
              this.mapService.clipPlanes(point, annotation['clipPlanes']);
            })
            annotation.saveObservable().subscribe();
            return;
          }
        });
      }
    }
  }

  clearAllClipPlanes(canNaviagateBack: boolean) {
    this.mapService.annotations.forEach(annotation => {
      if (annotation['annotationMode'] && (annotation['annotationMode'] === 'area' || annotation['annotationMode'] === 'volume') && annotation['points'] && annotation['points'].length > 0 && annotation['clipPlanes'] !== undefined) {
        delete annotation['clipPlanes'];
        annotation['points'].forEach(point => {
          this.mapService.clipPlanes(point, false);
        })
        annotation.saveObservable().subscribe();
      }
    });
    if (canNaviagateBack)
      this.navigateBack(this.location);
  }

  

  private saveProjectEPSGCode() {
    this.mapService.projectSettingEPSGCodeChanged.next(this.selectedEPSGCode.uid);
  }

  saveMeasurementUnit() {
    this.mapService.projectSettingMeasurementUnitChanged.next(this.feet_Meter);
  }

  clickedMap(movement: any, rightClick: boolean, checkedPosition): ClickDisplay {
    // console.log ( 'project-settings.comp :: clickedMap()');
    if (rightClick) {
      this.mapComp.detailsNav.close()
      this.router.navigate(['/app/projects/map', this.mapService.currentProject.id, 'layers'])
    }
    return ClickDisplay.None
  }

  nuke() {
    this.openConfirmDelete(() => this.project.destroyObservable().subscribe(s => {
      //remove the deleted project from the project list so that it dont appear in the projects list navigation
      this.fourD.projects = this.fourD.projects.filter(pp => pp.id !== this.project.id)
      this.router.navigate(['/app/projects'])
    }, e => this.openSnackBarError(e.message)), this.project.name)
  }

  selectEPSGCode() {
    this.openEPSGDialogWith('MAP.PHOTOGRAM.SELECT_EPSG_CODE').subscribe(code => {
      if (code) {
        this.selectedEPSGCode = code;
        this.saveProjectEPSGCode();
      }

    });
  }

}
